module.exports = __webpack_public_path__ + "img/new_btn_tabfirst_active.a798d46a.png";